import React from "react";
import logo from "../images/IEJL_logo.png";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import NewsletterForm from "./NewsletterForm";

export const Footer = () => {
  return (
    <footer className="bg-gray-300 py-10">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between space-y-8 md:space-y-0">
          {/* Logo and Social Media */}
          <div className="flex flex-col items-start m-6 mr-20 ml-16">
            <img src={logo} alt="Logo" className="h-16 w-auto mb-4" />
            <h3 className="text-xl font-raleway mb-4 mt-4">Follow us</h3>
            <div className="flex space-x-4 text-gray-700">
              <div className="flex space-x-4 text-gray-700">
                <a
                  href="https://www.facebook.com/internationalEconomicJusticeLeague/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-blue-600 transition-colors"
                >
                  <FaFacebook size={30} />
                </a>
                <a
                  href="https://x.com/iejl_org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-blue-400 transition-colors"
                >
                  <FaXTwitter size={30} />
                </a>
                <a
                  href="https://www.instagram.com/iejlorg/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-pink-500 transition-colors"
                >
                  <FaInstagram size={30} />
                </a>
                <a
                  href="https://www.linkedin.com/company/international-economic-justice-league-inc/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-blue-700 transition-colors"
                >
                  <FaLinkedin size={30} />
                </a>
              </div>
            </div>
          </div>

          {/* Location, Contact Info, Quick Links, and Image */}
          <div className="flex flex-col space-y-6">
            {/* First Row: Location and Contact Info */}
            <div className="flex justify-between space-x-8 ml-16 mr-16">
              <div>
                <h3 className="text-xl font-raleway mb-2">Location</h3>
                <address className="text-sm font-inter not-italic">
                  4667 MacArthur Blvd. <br />
                  Suite 400 <br />
                  Newport Beach, CA 92660
                </address>
              </div>
              <div>
                <h3 className="text-xl font-raleway mb-2">Contact Info</h3>
                <p className="text-sm font-inter">
                  info@iejl.com <br />
                  +1 949 887 0455
                </p>
              </div>
            </div>

            {/* Second Row: Quick Links and Image */}
            <div className="flex justify-between items-start space-x-8 ml-16 mr-16">
              <div>
                <a
                  href="https://app.candid.org/profile/9552622"
                  target="_blank"
                >
                  <img src="https://widgets.guidestar.org/prod/v1/pdp/transparency-seal/9552622/svg" />{" "}
                </a>
              </div>
            </div>
          </div>

          {/* Newsletter Form */}
          <NewsletterForm />
        </div>

        {/* Footer Bottom */}
        <div className="text-left text-sm font-inter text-black mt-10">
          <p>© 2025 International Economic Justice League &nbsp;&nbsp;&nbsp;</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
